export const InvoiceOtherPackageTags = ["invoice-other-package"];
